import Box from "@mui/material/Box";
import Grid from "components/primitives/Grid";
import { useAthleteMonitoringStatusesContext } from "hooks";
import useMonitoringTemplateItems from "hooks/useMonitoringTemplateItems";

interface MonitoringLabelsRowProps {}

function MonitoringLabelsRow(props: MonitoringLabelsRowProps) {
  const templateItems = useMonitoringTemplateItems();

  const [, { currentRagTemplateId }] = useAthleteMonitoringStatusesContext();

  return (
    <Grid container justifyContent="space-evenly" alignItems="center" height="100%">
      {templateItems?.map((item, itemIndex) => (
        <Grid key={[currentRagTemplateId, item.metadataId, itemIndex].join("_")} size={2} textAlign="center">
          <Box component="span" sx={{ color: "common.white", fontSize: "body2.fontSize" }}>
            {item.name}
          </Box>
        </Grid>
      ))}
    </Grid>
  );
}

export default MonitoringLabelsRow;
